import { useParams } from 'react-router-dom'

import TimeTrackingPolicy from 'modules/attendance/components/SettingItemPage/TimeTracking/TimeTrackingPolicy'
import { TabTypes } from 'modules/attendance/components/SettingItemPage/TimeTracking/tabs'

const SettingsItemPage = () => {
  const { settingId, tabId = TabTypes.edit } = useParams()

  return (
    <TimeTrackingPolicy
      settingId={settingId === 'default' ? settingId : Number(settingId)}
      tabId={tabId}
    />
  )
}

export default SettingsItemPage
